import { FunctionComponent, ReactElement } from 'react';
import TextField from '@/components/ui/form-inputs/TextField';
import { SITE_FORM_KEY } from '@/shared/constants/form-keys';
import SelectField from '@/components/ui/form-inputs/SelectField';
import { Timezone } from '@/api/timezones/types';
import { State } from '@/api/states/types';
import SiteFormSection from '../components/SiteFormSection';
import { SiteFormSectionProps } from './types';

interface SectionBasicInformationProps extends SiteFormSectionProps {
	timezones?: Timezone[];
	states?: State[];
}

const SectionBasicInformation: FunctionComponent<SectionBasicInformationProps> = ({
	formModel,
	setFormModel,
	timezones,
	states,
}): ReactElement => (
	<SiteFormSection
		title="Basic information"
		description="Enter the name and location of this site."
		width="360px"
	>
		<TextField
			name="name"
			label="Site name"
			formKey={SITE_FORM_KEY}
			value={formModel.name}
			onChange={(event) => setFormModel({ ...formModel, name: event.target.value })}
		/>
		<TextField
			name="address"
			label="Address"
			formKey={SITE_FORM_KEY}
			value={formModel.address}
			onChange={(event) => setFormModel({ ...formModel, address: event.target.value })}
		/>
		<TextField
			name="city"
			label="City"
			formKey={SITE_FORM_KEY}
			value={formModel.city}
			onChange={(event) => setFormModel({ ...formModel, city: event.target.value })}
		/>
		<SelectField
			name="state"
			label="State"
			formKey={SITE_FORM_KEY}
			value={formModel.state}
			onChange={(event) => setFormModel({ ...formModel, state: event.target.value })}
			options={states?.map((state) => ({
				value: state,
				label: state,
			}))}
		/>
		<TextField
			name="zipCode"
			label="Zip code"
			formKey={SITE_FORM_KEY}
			value={formModel.zip}
			onChange={(event) => setFormModel({ ...formModel, zip: event.target.value })}
		/>
		<SelectField
			name="timeZone"
			label="Time zone"
			formKey={SITE_FORM_KEY}
			value={formModel.timeZone}
			onChange={(event) => setFormModel({ ...formModel, timeZone: event.target.value })}
			options={timezones?.map((timezone) => ({
				value: timezone,
				label: timezone,
			}))}
		/>
	</SiteFormSection>
);

export default SectionBasicInformation;
